export enum Sections{
    FormularioVinculacion = 1,
    Generalidades = 2,
    Localizacion = 4,
    Identicacion = 3,
    RepLegal = 5,
    AdminPortal = 6,
    Accionistas = 7,
    Firmas = 8,
    AccesoInventario = 10,
    Etica = 11
}